<template>
  <funding-base :state="state" :current-funding-pot-id="fundingPot.id">
    <div class="container pt-12">
      <template v-if="!requests">
        <div class="border-4 border-dashed p-12 text-center max-w-md mx-auto">
          <h1>No applications available</h1>
          <p>
            There have been no applications submitted for {{ $config.name }}
            {{ $config.current_wave }}
          </p>
        </div>
      </template>
      <template v-else>
        <div class="bg-white shadow-lg">
          <article
            v-for="(request, index) in requests"
            :key="request.id"
            class="px-6 py-4 flex flex-col bg-white border-grey-300 relative"
            :class="index == requests.length - 1 ? 'border-b-0' : 'border-b-2'"
          >
            <div class="flex items-center mb-6">
              <div class="mr-6">
                <h2 class="text-xl leading-tight truncate mb-1">
                  {{ request.name | sentencecase }}
                </h2>
                <p>
                  {{ request.application_data.company_name }} |
                  {{ request.application_data.address }} |
                  {{ request.category }}
                </p>
              </div>
              <div class="ml-auto">
                <a
                  :href="
                    route('funding.delivery-partner-requests.download', [
                      fundingPot.id,
                      request.id
                    ])
                  "
                  class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-primary-300 text-primary-800 shadow text-sm font-semibold bg-primary-50 hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none ml-2"
                  download
                >
                  Download File(s)
                </a>
              </div>
            </div>
            <dl class="flex text-xs border-t pt-4">
              <div class="mr-6 flex">
                <dt class="font-bold mr-1">Submitted at:</dt>
                <dd>
                  {{
                    format(parseISO(request.created_at), "do MMMM yyyy hh:mm")
                  }}
                </dd>
              </div>
              <div class="mr-6 flex">
                <dt class="font-bold mr-1">Email</dt>
                <dd>{{ request.email }}</dd>
              </div>
            </dl>
          </article>
        </div>
        <div class="mt-6 w-48">
          <app-button
            tag="a"
            :href="route('funding.delivery-partner-requests.export', [fundingPot.id])"
            download
            data-no-turbolink
          >
            Export
          </app-button>
        </div>
      </template>
    </div>
  </funding-base>
</template>

<script>
export default {
  name: "FundingDeliveryPartnerRequestsIndex",
  computed: {
    fundingPot() {
      return this.state.funding_pot;
    },
    requests() {
      return this.state.requests;
    }
  }
};
</script>
